import {Component, inject, OnInit} from '@angular/core';
import {ClientService} from '../../core/services/client.service';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  standalone: true,
})
export class HeaderComponent implements OnInit {
  private clientService = inject(ClientService);
  clientId: string = this.clientService.clientId;

  ngOnInit() {
    this.clientService.clientId$.subscribe(id => {
      this.clientId = id;
    });
  }

  getLogoPath(clientId: string = ''): string {
    switch (clientId) {
      case 'celcomdigi':
        return '/assets/images/celcomdigi-logo-300x125.svg';
      case 'maxis':
        return '/assets/images/maxis-logo-300x125.svg';
      case 'ttpoi-web':
      default:
        return '/assets/images/adaptis-logo-300x125.svg';
    }
  }
}
